/*
 * @Author: your name
 * @Date: 2022-04-25 18:27:16
 * @LastEditTime: 2022-04-25 19:38:11
 * @LastEditors: your name
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /privatization-webim/src/utils/ajax.ts
 */
import axios from 'axios';
// 改为从imsdk中获得基础api的domain。 by justin 20220506
import { Domain } from '@/imsdk/index';
import globalWin from '@/utils/globalWin';
const tsglobalWin:any = globalWin;
// 获得内置域名
const IM_DOMAIN = Domain.getSDKDomain();

// import Vue from 'vue';
// 创建请求实例
const instance: any = axios.create({
  // 初始配置
  baseURL: IM_DOMAIN.api,
  timeout: 30 * 1000,
});

instance.interceptors.request.use((config) => {
  if (!config.headers) {
    config.headers = {};
  }
  // isApexApi 是否是apex接口，apex要么不需要域名（用baseurl）,要么域名中有gateway.qidian
  const isApexApi = !(/^(https?:)?\/\/([a-zA-Z0-9]+\.)+[a-zA-Z0-9]+/.test(config.url) && config.url.indexOf('gateway') === -1);
  if (isApexApi) {
    config.headers['X-Tenant-Id'] =  tsglobalWin.kfuin;
  }
  return config;
});

export default instance;
// 待完善
